import React from 'react'
import { authHooks, AuthWithCartoon, InstallButton } from 'pages/Auth'
import { ForgotUserNameOrPassword, Logo, LoginStyles, UnregisterUserStyles } from '../Style'
import { LoginCart } from 'assets'
import { loginHooks, validate } from '.'
import { ReactComponent as LogoIcon } from 'assets/LogoGo.svg';
import { Divider, SvgIcon } from '@mui/material'
import { createTicketHooks } from 'pages/CreateTicket'
import { Button } from 'components/Form'
import { LightButton, Space } from 'styles/GlobalStyle'
import { ReactComponent as LogoutIcon } from 'assets/icons/Logout.svg';

const UnregisterUser = () => {
    const openTicket = createTicketHooks.useAlert()
    const { logout, logoutPending } = authHooks.useLogout()

    return (
        <UnregisterUserStyles>
            <Logo>
                <SvgIcon component={LogoIcon} color="black" inheritViewBox />
            </Logo>
            <div className='logout-btn'>
                <Button
                    loading={logoutPending}
                    disabled={logoutPending}
                    action={logout}
                    width={"120px"}
                    direction="rtl"
                    color="light"
                    label=" התנתק "
                    icon={<SvgIcon fontSize="small" component={LogoutIcon} inheritViewBox />}
                />
            </div>
            <AuthWithCartoon
                cartoon={LoginCart}
                cartoonSize={{
                    height: 600,
                }}
            >
                <div className='message'>
                    <div>{" אינכם רשומים במערכת"}</div>
                    <div>{" אנא פנו לצוות התמיכה שלנו"}</div>
                    <div>{"על מנת לסדר את תהליך הרישום"}</div>
                    <Space />
                    <Button color="thirdly" label="ליצרת קשר" action={() => openTicket(true)} />
                </div>
            </AuthWithCartoon>
        </UnregisterUserStyles>
    )
}
export default UnregisterUser